import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserPortfolioStocks } from "layouts/applications/data-tables/data/getData";

const initialState = {
	loading: true,
	stocks: [],
	diversifiedSectors: [],
	diversifiedStocks: [],
};

const findCategory = (sectorArray, sector) => {
	let lengthOfArray = sectorArray.length;
	for (let i = 0; i < lengthOfArray; i++) {
		if (sectorArray[i]["sector"] === sector) {
			return i;
		}
	}
	return -1;
};

const sortForDiversificationChart = portfolioItems => {
	let sectorArray = [];
	let stockArray = [];
	for (let i = 0; i < portfolioItems.length; i++) {
		let currentSectorArrayLength = sectorArray.length;
		let item = portfolioItems[i];
		const sector = item.companySector;
		const ticker = item.symbol;
		const marketPrice = item.currentMktPrice ? item.currentMktPrice : item.tradePrice; // use trade price if current market price not available
		const totalValue = parseInt(item.quantity * marketPrice);
		const itemObject = { sector: sector, ticker: ticker, totalValue: totalValue };
		let index = findCategory(sectorArray, sector);
		if (index === -1) {
			//create new sectory in array
			sectorArray[currentSectorArrayLength] = { sector: sector, value: totalValue, stocks: [itemObject] };
		} else {
			sectorArray[index].stocks.push(itemObject);
			sectorArray[index] = { ...sectorArray[index], value: sectorArray[index].value + totalValue };
			//append existing array
		}
	}

	let lengthOfSector = sectorArray.length;
	for (let i = 0; i < lengthOfSector; i++) {
		let lengthOfStocks = sectorArray[i].stocks.length;
		for (let j = 0; j < lengthOfStocks; j++) {
			stockArray.push(sectorArray[i].stocks[j]);
		}
	}

	console.log(sectorArray, stockArray);

	return {
		sectors: sectorArray,
		stocks: stockArray,
	};
};

export const loadUserStocks = createAsyncThunk("portfolio/stock", async () => {
	const userStocks = await getUserPortfolioStocks();
	return userStocks;
});

export const portfolioSlice = createSlice({
	name: "userStock",
	initialState,
	reducers: {
		buyStock: (state, action) => {
			state.stocks.push(action.payload);
		},
		sellStock: (state, action) => {
			console.log(action.payload)
			state.stocks = state.stocks.filter(stock => stock.id !== action.payload.id)
		},
	},
	extraReducers: builder => {
		builder.addCase(loadUserStocks.fulfilled, (state, action) => {
			if (action.payload === null) return;
			state.loading = false;
			state.stocks = action.payload;

			//update diversifications
			if (Array.isArray(action.payload) && action.payload.length > 0) {
				const { sectors, stocks } = sortForDiversificationChart(action.payload);
				state.diversifiedSectors = sectors;
				state.diversifiedStocks = stocks;
			}
		});
	},
});

// Action creators are generated for each case reducer function
export const { buyStock, sellStock } = portfolioSlice.actions;

export default portfolioSlice.reducer;
